import http from "../http-common";

// MODIFICATO: La funzione getAll ora accetta un parametro opzionale 'sede'
const getAll = (sede) => {
    let url = "/aziende";

    // Se viene fornita una sede, la aggiunge come parametro di query all'URL
    if (sede) {
        url += `?sede=${sede}`;
    }

    return http.get(url);
};

const get = id => {
    return http.get(`/aziende/${id}`);
};

const create = data => {
    return http.post("/aziende", data);
};

const update = (id, data) => {
    return http.put(`/aziende/${id}`, data);
};

const remove = id => {
    return http.delete(`/aziende/${id}`);
};

const removeAll = () => {
    return http.delete(`/aziende`);
};

// Modificato per essere più specifico per le aziende
const findByRagioneSociale = ragioneSociale => {
    return http.get(`/aziende?ragione_sociale=${ragioneSociale}`);
};

const AziendaService = {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
    findByRagioneSociale
};

export default AziendaService;